export * from './dialog-config.model';
export * from './dialog-config.mock';
export * from './dialog-config.schema';
